import { Verification } from "../model";

export class VerificationSaveCommand{
    public verify: Verification;

    constructor(verification:Verification){
        this.verify = verification;
    }
}